import { useEffect } from 'react';
import { useFetch } from 'hooks/fetch/useFetch';
import fe_clr from 'theme/global-colors'; // shared object
import { F_BOOSTRAP } from 'api/full_eido_api';
import { _bootstrap } from 'state/store.bootstrap';
import { useGet, useSet } from 'state/jotai';
import { useTranslation } from 'react-i18next';
import { boostrap } from 'state/store.fullEido';

export const useFetchFullEido_Colors = () => {
  const pid = useGet(_bootstrap).projectids?.[0] || null;
  const setFullEidoBoostrap = useSet(boostrap)
  const { i18n: { language } } = useTranslation();

  const { D: clr } = useFetch({
    url: F_BOOSTRAP(pid, language),
    file: 'useFetchFullEido_Colors.js',
  });

  const res = !!clr && Object.keys(clr).length > 0;

  useEffect(() => {
    if (res && clr?.Theme) {
      // ✅ Mutate fe_clr instead of reassigning
      Object.assign(fe_clr, clr.Theme);

      // ✅ Optionally expose to global window
      window.f_clr = fe_clr;
      setFullEidoBoostrap(clr)
    }
  }, [clr, res, language]);

  return { clr: fe_clr, res };
};
